import {
  GET_ELIGIBLE_LINE_COUNT_REQUEST,
  GET_ELIGIBLE_LINE_COUNT_SUCCESS,
  GET_ELIGIBLE_LINE_COUNT_FAILURE,
  SET_NO_OF_LINE_REQUEST,
  GET_DIST_CARD_PROFILE_SUCCESS,
  GET_DIST_CARD_PROFILE_REQUEST,
  GET_DIST_CARD_PROFILE_FAILURE,
  PDPA_GET_ORDER_DETAILS_FAILURE,
  PDPA_GET_ORDER_DETAILS_REQUEST,
  PDPA_GET_ORDER_DETAILS_SUCCESS,
  TERMINATE_PARENT_SVC_NUM_REQUEST,
  TERMINATE_PARENT_SVC_NUM_SUCCESS,
  TERMINATE_PARENT_SVC_NUM_FAILURE,
  GET_SIM_CHARGE_FAILURE,
  GET_SIM_CHARGE_REQUEST,
  GET_SIM_CHARGE_SUCCESS,
  GET_RESET_CARD_PROFILE,
  WAIVER_REQUEST_STATUS_UPDATE_REQUEST,
  WAIVER_REQUEST_STATUS_UPDATE_SUCCESS,
  WAIVER_REQUEST_STATUS_UPDATE_FAILURE,
  GET_WAIVERED_ORDER_REQUEST,
  GET_WAIVERED_ORDER_SUCCESS,
  GET_WAIVERED_ORDER_FAILURE,
  ORDER_SAVE_SMART_TEMPLATE_REQUEST,
  ORDER_SAVE_SMART_TEMPLATE_SUCCESS,
  ORDER_SAVE_SMART_TEMPLATE_FAILURE,
  SET_IS_SMART_TEMPLATE_FLOW,
  EDIT_SMART_TEMPLATE_FAILURE,
  EDIT_SMART_TEMPLATE_REQUEST,
  EDIT_SMART_TEMPLATE_SUCCESS,
  SET_DELETE_SMART_TEMPLATE_ID,
  REFIT_LINE_SUBMIT_REQUEST,
  REFIT_LINE_SUBMIT_SUCCESS,
  REFIT_LINE_SUBMIT_ERROR,
  PDPA_QR_IMAGE_RET_REQUEST,
  PDPA_QR_IMAGE_RET_SUCCESS,
  PDPA_QR_IMAGE_RET_ERROR,
  GET_BULK_ORDER_DETAILS_BY_ITEM_ID_REQUEST,
  GET_BULK_ORDER_DETAILS_BY_ITEM_ID_ERROR,
  GET_BULK_ORDER_DETAILS_BY_ITEM_ID_SUCCESS
} from './actionTypes';
import {
  GetEligibleLineCount,
  GetEligibleLineCountSuccess,
  GetEligibleLineCountFailure,
  IGetPaymentDetailsSuccess,
  IGetPaymentDetails,
  IGetPaymentDetailsFailure,
  ISubmitOrder,
  ISubmitOrderSuccess,
  ISubmitOrderFailure,
  IGetOrderDetails,
  IGetOrderDetailsFailure,
  IGetOrderDetailsSuccess,
  ICreateNewOrder,
  ICreateStore,
  ISaveToCart,
  ISaveToCartSuccess,
  ISaveToCartFailure,
  IWaiverRequest,
  IGetTemplateOrderDetails,
  IGetTemplateOrderDetailsSuccess,
  IGetTemplateOrderDetailsFailure,
  RefitLineSubmitRequest,
  RefitLineSubmitSuccess,
  RefitLineSubmitFailure
} from './models/types';

export const saveToCart = {
  request: (
    orderDetails,
    toOrderDetails = false,
    recalculateOnly = false,
    checkout = false,
    callback = (_param) => { }
  ): ISaveToCart => ({
    type: 'ORDER_SAVE_TO_CART_REQUEST',
    orderDetails,
    toOrderDetails,
    recalculateOnly,
    checkout,
    callback
  }),
  success: (data): ISaveToCartSuccess => ({
    type: 'ORDER_SAVE_TO_CART_SUCCESS',
    data
  }),
  failure: (error): ISaveToCartFailure => ({
    type: 'ORDER_SAVE_TO_CART_FAILURE',
    error
  })
};
export const ORDER_GET_ORDER_DETAILS_REQUEST = 'ORDER_GET_ORDER_DETAILS_REQUEST';
export const ORDER_GET_ORDER_DETAILS_SUCCESS = 'ORDER_GET_ORDER_DETAILS_SUCCESS';
export const ORDER_GET_ORDER_DETAILS_FAILURE = 'ORDER_GET_ORDER_DETAILS_FAILURE';

export const getOrderDetails = {
  request: (cartId): IGetOrderDetails => ({
    type: ORDER_GET_ORDER_DETAILS_REQUEST,
    cartId
  }),
  success: (data): IGetOrderDetailsSuccess => ({
    type: ORDER_GET_ORDER_DETAILS_SUCCESS,
    data
  }),
  failure: (error): IGetOrderDetailsFailure => ({
    type: ORDER_GET_ORDER_DETAILS_FAILURE,
    error
  })
};

export const createNewOrder = {
  request: (order): ICreateNewOrder => ({
    type: 'ORDER_CREATE_NEW_ORDER_REQUEST',
    order
  }),
  store: (order): ICreateStore => ({
    type: 'ORDER_CREATE_NEW_ORDER_STORE',
    order
  })
};

export const storeSelection = ({
  selection,
  activeStep = 0,
  saveToCart = false,
  toOrderDetails = false,
  ceaseDate = ''
}) => ({
  type: 'ORDER_STORE_SELECTION',
  selection,
  activeStep,
  saveToCart,
  toOrderDetails,
  ceaseDate
});
export const SUBMIT_ORDER_REQUEST = 'SUBMIT_ORDER_REQUEST';
export const SUBMIT_ORDER_SUCCESS = 'SUBMIT_ORDER_SUCCESS';
export const SUBMIT_ORDER_ERROR = 'SUBMIT_ORDER_ERROR';
export const submitOrder = {
  request: (orderInfo): ISubmitOrder => ({
    type: SUBMIT_ORDER_REQUEST,
    orderInfo
  }),
  success: (data): ISubmitOrderSuccess => ({
    type: SUBMIT_ORDER_SUCCESS,
    data
  }),
  failure: (error): ISubmitOrderFailure => ({ type: SUBMIT_ORDER_ERROR, error })
};

export const ORDER_PAYMENT_DETAILS_REQUEST = 'ORDER_PAYMENT_DETAILS_REQUEST';
export const ORDER_PAYMENT_DETAILS_SUCCESS = 'ORDER_PAYMENT_DETAILS_SUCCESS';
export const ORDER_PAYMENT_DETAILS_ERROR = 'ORDER_PAYMENT_DETAILS_ERROR';
export const getPaymentDetails = {
  request: (merchantRefNum): IGetPaymentDetails => ({
    type: ORDER_PAYMENT_DETAILS_REQUEST,
    merchantRefNum
  }),
  success: (data): IGetPaymentDetailsSuccess => ({
    type: ORDER_PAYMENT_DETAILS_SUCCESS,
    data
  }),
  failure: (error): IGetPaymentDetailsFailure => ({
    type: ORDER_PAYMENT_DETAILS_ERROR,
    error
  })
};

export const getEligibleLineCount = {
  request: (userInfo): GetEligibleLineCount => ({
    type: GET_ELIGIBLE_LINE_COUNT_REQUEST,
    userInfo
  }),
  success: (data): GetEligibleLineCountSuccess => ({
    type: GET_ELIGIBLE_LINE_COUNT_SUCCESS,
    data
  }),
  failure: (error): GetEligibleLineCountFailure => ({
    type: GET_ELIGIBLE_LINE_COUNT_FAILURE,
    error
  })
};
export const setNoOfLines = {
  request: (noOfLines) => ({
    type: SET_NO_OF_LINE_REQUEST,
    noOfLines
  })
};

export const getDistCardProfile = {
  request: (reqData) => ({
    type: GET_DIST_CARD_PROFILE_REQUEST,
    reqData
  }),
  success: (data) => ({
    type: GET_DIST_CARD_PROFILE_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: GET_DIST_CARD_PROFILE_FAILURE,
    error
  })
};
export const getSimCharge = {
  request: (reqData, msaHeaderId) => ({
    type: GET_SIM_CHARGE_REQUEST,
    reqData,
    msaHeaderId
  }),
  success: (data) => ({
    type: GET_SIM_CHARGE_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: GET_SIM_CHARGE_FAILURE,
    error
  })
};
export const getPdpaOrder = {
  request: (orderId) => ({ type: PDPA_GET_ORDER_DETAILS_REQUEST, orderId }),
  success: (data) => ({ type: PDPA_GET_ORDER_DETAILS_SUCCESS, data }),
  failure: (error) => ({ type: PDPA_GET_ORDER_DETAILS_FAILURE, error })
};

export const terminateParentSvcNo = {
  request: (reqData, callback) => ({ type: TERMINATE_PARENT_SVC_NUM_REQUEST, reqData, callback }),
  success: (data) => ({ type: TERMINATE_PARENT_SVC_NUM_SUCCESS, data }),
  failure: (error) => ({ type: TERMINATE_PARENT_SVC_NUM_FAILURE, error })
};

export const resetCardProfile = () => ({ type: GET_RESET_CARD_PROFILE });

export const updateWaiverRequestStatus = {
  request: (reqData: IWaiverRequest) => ({ type: WAIVER_REQUEST_STATUS_UPDATE_REQUEST, reqData }),
  success: (data) => ({ type: WAIVER_REQUEST_STATUS_UPDATE_SUCCESS, data }),
  failure: (error) => ({ type: WAIVER_REQUEST_STATUS_UPDATE_FAILURE, error })
};

export const getWaiveredOrder = {
  request: (reqData) => ({ type: GET_WAIVERED_ORDER_REQUEST, reqData }),
  success: (data) => ({ type: GET_WAIVERED_ORDER_SUCCESS, data }),
  failure: (error) => ({ type: GET_WAIVERED_ORDER_FAILURE, error })
};

export const ORDER_GET_TEMPLATE_ORDER_DETAILS_REQUEST = 'ORDER_GET_TEMPLATE_ORDER_DETAILS_REQUEST';
export const ORDER_GET_TEMPLATE_ORDER_DETAILS_SUCCESS = 'ORDER_GET_TEMPLATE_ORDER_DETAILS_SUCCESS';
export const ORDER_GET_TEMPLATE_ORDER_DETAILS_FAILURE = 'ORDER_GET_TEMPLATE_ORDER_DETAILS_FAILURE';

export const getTemplateOrderDetails = {
  request: (templateId, orderType, callback): IGetTemplateOrderDetails => ({
    type: ORDER_GET_TEMPLATE_ORDER_DETAILS_REQUEST,
    templateId,
    orderType,
    callback
  }),
  success: (data): IGetTemplateOrderDetailsSuccess => ({
    type: ORDER_GET_TEMPLATE_ORDER_DETAILS_SUCCESS,
    data
  }),
  failure: (error): IGetTemplateOrderDetailsFailure => ({
    type: ORDER_GET_TEMPLATE_ORDER_DETAILS_FAILURE,
    error
  })
};

export const saveSmartTemplate = {
  request: (orderDetails, checkoutDetails = {}, checkout = false, recalculateOnly = false, callback = (_param) => { }) => ({
    type: ORDER_SAVE_SMART_TEMPLATE_REQUEST,
    orderDetails,
    checkoutDetails,
    checkout,
    recalculateOnly,
    callback
  }),
  success: (data) => ({ type: ORDER_SAVE_SMART_TEMPLATE_SUCCESS, data }),
  failure: (error) => ({ type: ORDER_SAVE_SMART_TEMPLATE_FAILURE, error })
};

export const setIsSmartTemplateFlow = (value) => ({ type: SET_IS_SMART_TEMPLATE_FLOW, value });

export const editSmartTemplate = {
  request: (templateId, category, callback) => ({
    type: EDIT_SMART_TEMPLATE_REQUEST,
    templateId,
    category,
    callback
  }),
  success: (data) => ({ type: EDIT_SMART_TEMPLATE_SUCCESS, data }),
  failure: (error) => ({ type: EDIT_SMART_TEMPLATE_FAILURE, error })
};

export const setDeleteSmartTemplateId = (value) => ({ type: SET_DELETE_SMART_TEMPLATE_ID, value });

export const refitLineSubmit = {
  request: (reqData): RefitLineSubmitRequest => ({
    type: REFIT_LINE_SUBMIT_REQUEST,
    reqData
  }),
  success: (data): RefitLineSubmitSuccess => ({ type: REFIT_LINE_SUBMIT_SUCCESS, data }),
  failure: (error): RefitLineSubmitFailure => ({ type: REFIT_LINE_SUBMIT_ERROR, error })
};

export const esimQRPdpaRetrieval = {
  request: (reqData): any => ({
    type: PDPA_QR_IMAGE_RET_REQUEST,
    reqData
  }),
  success: (data): any => ({ type: PDPA_QR_IMAGE_RET_SUCCESS, data }),
  failure: (error): any => ({ type: PDPA_QR_IMAGE_RET_ERROR, error })
}

export const getBulkOrderDetailsByItemId = {
  request: (payload) => ({ type: GET_BULK_ORDER_DETAILS_BY_ITEM_ID_REQUEST, payload }),
  success: (data) => ({ type: GET_BULK_ORDER_DETAILS_BY_ITEM_ID_SUCCESS, data }),
  failure: (error) => ({ type: GET_BULK_ORDER_DETAILS_BY_ITEM_ID_ERROR, error })
};